var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styleMain},[_c('el-date-picker',{attrs:{"size":"small","type":"date","placeholder":"","format":"yyyy-MM-dd","default-value":_vm.date,"clearable":false},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }